import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import MarketingLayout from "@/components/marketing/MarketingLayout";
import DashboardLayout from "@/components/dashboard/DashboardLayout";

import Home from "@/pages/marketing/Home";
import Security from "@/pages/marketing/Security";
import Developers from "@/pages/marketing/Developers";
import Company from "@/pages/marketing/Company";
import EarlyAccess from "@/pages/marketing/EarlyAccess";
import Careers from "@/pages/marketing/Careers";
import Contact from "@/pages/marketing/Contact";
import AIEnquiry from "@/pages/marketing/AIEnquiry";
import Solutions from "@/pages/marketing/Solutions";

import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import AuthCallback from "@/pages/auth/AuthCallback";

import Overview from "@/pages/app/Overview";
import Agents from "@/pages/app/Agents";
import AgentDetail from "@/pages/app/AgentDetail";
import Wallets from "@/pages/app/Wallets";
import Transactions from "@/pages/app/Transactions";
import Approvals from "@/pages/app/Approvals";
import Policies from "@/pages/app/Policies";
import Analytics from "@/pages/app/Analytics";
import SecurityCenter from "@/pages/app/SecurityCenter";
import SettingsPage from "@/pages/app/Settings";
import WaitlistInbox from "@/pages/app/WaitlistInbox";
import LeadsInbox from "@/pages/app/LeadsInbox";
import ContentStudio from "@/pages/app/ContentStudio";
import CareersAdmin from "@/pages/app/CareersAdmin";

function Marketing({ children }) {
  return <MarketingLayout>{children}</MarketingLayout>;
}

function Dashboard({ children }) {
  return (
    <ProtectedRoute>
      <DashboardLayout>{children}</DashboardLayout>
    </ProtectedRoute>
  );
}

function AppRoutes() {
  const location = useLocation();
  // Process Google OAuth return BEFORE normal routing to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Marketing><Home /></Marketing>} />
      <Route path="/security" element={<Marketing><Security /></Marketing>} />
      <Route path="/solutions" element={<Marketing><Solutions /></Marketing>} />
      <Route path="/developers" element={<Marketing><Developers /></Marketing>} />
      <Route path="/company" element={<Marketing><Company /></Marketing>} />
      <Route path="/about" element={<Marketing><Company /></Marketing>} />
      <Route path="/careers" element={<Marketing><Careers /></Marketing>} />
      <Route path="/contact" element={<Marketing><Contact /></Marketing>} />
      <Route path="/ai" element={<Marketing><AIEnquiry /></Marketing>} />
      <Route path="/early-access" element={<Marketing><EarlyAccess /></Marketing>} />

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      <Route path="/app" element={<Dashboard><Overview /></Dashboard>} />
      <Route path="/app/agents" element={<Dashboard><Agents /></Dashboard>} />
      <Route path="/app/agents/:id" element={<Dashboard><AgentDetail /></Dashboard>} />
      <Route path="/app/wallets" element={<Dashboard><Wallets /></Dashboard>} />
      <Route path="/app/transactions" element={<Dashboard><Transactions /></Dashboard>} />
      <Route path="/app/approvals" element={<Dashboard><Approvals /></Dashboard>} />
      <Route path="/app/policies" element={<Dashboard><Policies /></Dashboard>} />
      <Route path="/app/analytics" element={<Dashboard><Analytics /></Dashboard>} />
      <Route path="/app/security" element={<Dashboard><SecurityCenter /></Dashboard>} />
      <Route path="/app/waitlist" element={<Dashboard><WaitlistInbox /></Dashboard>} />
      <Route path="/app/leads" element={<Dashboard><LeadsInbox /></Dashboard>} />
      <Route path="/app/content" element={<Dashboard><ContentStudio /></Dashboard>} />
      <Route path="/app/careers" element={<Dashboard><CareersAdmin /></Dashboard>} />
      <Route path="/app/settings" element={<Dashboard><SettingsPage /></Dashboard>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="top-right" richColors theme="dark" />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
